import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import {
  setGlobalCounter,
  decrementGlobalCounter,
  incrementGlobalCounter,
} from '../actions/counter';

export default handleActions<DamzState['counter'], any>(
  {
    [`${setGlobalCounter}`]: (
      state,
      action: ReturnType<typeof setGlobalCounter>
    ) => ({
      ...state,
      conversations: action.payload.conversations,
      requests: action.payload.requests,
    }),
    [`${decrementGlobalCounter}`]: (
      state,
      action: ReturnType<typeof decrementGlobalCounter>
    ) => ({
      ...state,
      conversations: Math.max(
        0,
        state.conversations - action.payload.room_ids.length
      ),
    }),
    [`${incrementGlobalCounter}`]: (
      state,
      action: ReturnType<typeof incrementGlobalCounter>
    ) => ({
      ...state,
      conversations: state.conversations + action.payload.room_ids.length,
    }),
  },
  {
    conversations: 0,
    requests: 0,
  }
);
